import type { RequestCookies } from 'next/dist/compiled/@edge-runtime/cookies'
import type { ReadonlyRequestCookies } from 'next/dist/server/web/spec-extension/adapters/request-cookies'

import { MomentEnv } from '@/app/moment-env'
import { Environment } from '@/types/enums/environments'

const AUTH_COOKIE_BY_ENV: Record<Environment, string> = {
  [Environment.STAGING]: 'auth-token-staging',
  [Environment.PROD_PAPER]: 'auth-token-prod-ppr',
  [Environment.PROD]: 'auth-token-prod',
}
const DEFAULT_AUTH_COOKIE_ENVIRONMENT = Environment.PROD_PAPER
const authCookieEnvironment =
  MomentEnv.Environment === Environment.STAGING ||
  MomentEnv.Environment === Environment.PROD_PAPER ||
  MomentEnv.Environment === Environment.PROD
    ? MomentEnv.Environment
    : DEFAULT_AUTH_COOKIE_ENVIRONMENT
export const AUTH_COOKIE = AUTH_COOKIE_BY_ENV[authCookieEnvironment]
export const MOMENT_DOMAIN = 'moment.com'
export const AUTH_COOKIE_DOMAIN = `.${MOMENT_DOMAIN}`

// Sibling to the auth cookie, set by the SSO callback so the impersonation
// probe can surface the reason (WorkOS keeps it off the access token). Derived
// from AUTH_COOKIE so it stays env-scoped across the shared .moment.com domain.
export const IMPERSONATION_REASON_COOKIE = `${AUTH_COOKIE}-impersonation-reason`

export function getServerAuthCookieValue(
  cookieStore: ReadonlyRequestCookies,
): string | undefined {
  return cookieStore.get(AUTH_COOKIE)?.value
}

export function getRequestAuthCookieValue(
  requestCookies: RequestCookies,
): string | undefined {
  return requestCookies.get(AUTH_COOKIE)?.value
}
